import {Component} from '@angular/core';
import {Response, Headers, RequestOptions, Http} from '@angular/http';
import {ApiClientService} from '../../../services/api-client.service';
import {SettingsAmenity} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsIntegrationsService} from '../../../services/settings-integrations.service';
import { environment } from 'environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-integrations-detailed-view',
    templateUrl: './settings-integrations-detailed-view.component.html',
    styleUrls: ['./settings-integrations-detailed-view.component.scss']
})

export class SettingsIntegrationsDetailedViewComponent {
    title = 'Resident';
    disabledFileInput = false;
    data: SettingsAmenity;
    navPosition = 'about';
    attachments: Array<any> = [];
    noEdit = false;

    constructor(
      public api: ApiClientService,
      public settingsIntegrationsService: SettingsIntegrationsService,
      public directoryService: DirectoryService,
      private http: Http,
      private authTokenService: AuthTokenService
    ) {}

    onSubmit(data: any): void {
        this.noEdit = true;
        data.timeSequenceType = this.settingsIntegrationsService.selectedItemData.timeSequenceType;
        const url = `/v1/amenity/${this.settingsIntegrationsService.selectedItemData.id}.json`;
        this.settingsIntegrationsService.api.patch('domainAmenities', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            error => this.api.errorHandler(error, 'Update failed!'),
            () => this.noEdit = false
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.settingsIntegrationsService.toggleDetailedView(this.settingsIntegrationsService.selectedItemData, true);
        this.settingsIntegrationsService.getData();
        if (close) this.settingsIntegrationsService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.settingsIntegrationsService.selectedItemData.formFields)
            this.settingsIntegrationsService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    addImage(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 1000000) {
            toastr.warning('Maximum image size is 1MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.settingsIntegrationsService.modalSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainAmenities}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Image path should not be blank.');
                    return;
                }
                this.settingsIntegrationsService.selectedItemData.amenityImage = res.path;
                this.onSubmit({amenityImage: this.settingsIntegrationsService.selectedItemData.amenityImage});
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => {
                this.settingsIntegrationsService.modalSpinnerShow = false;
                this.disabledFileInput = false;
            }
        );
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsIntegrationsService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations-detailed-view/settings-integrations-detailed-view.component.ts